module.exports = __webpack_public_path__ + "static/media/undraw_feeling_proud_qne1.13c6d2e5.svg";